import { Component,Renderer2, ElementRef, ViewChild,Inject  } from "@angular/core";
import { DOCUMENT } from '@angular/common';
import {
  pageInfo,
  Constant,
  PlatFormType,
  PlatFormNames,
  loginActivity
} from "src/app/common/constant/constant";
import "hammerjs";
import { Title } from "@angular/platform-browser";
import { NotificationService } from './services/notification/notification.service';
import { Router, NavigationEnd } from '@angular/router';
import { CallsService } from './controller/calls.service';
import { ThemeService } from './services/theme.service';
import { CommonService } from "./services/common/common.service";
import { AuthenticationService } from "./services/authentication/authentication.service";
import { ApiService } from './services/api/api.service';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { LocalStorageItem } from 'src/app/common/constant/constant';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PrimeNGConfig } from 'primeng/api';
import { Message, MessageService } from 'primeng/api'
import * as moment from "moment";
import {AllDataApiService} from "./services/all-data-api/all-data-api.service";
import { AuthGuard } from "./components/_helpers/auth.guard";
import { IndexDBStorageService } from "./services/index-db-storage/index-db-storage.service";
declare var $: any;
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {

  public userId;
  public domainId;
public roundCount=0;
  isMicOn: boolean = false;
  testing = [1];
  platformId: string;
  PlatFormName: string;
  maper: any = {
    threads: "Threads",
    documents: "Tech Info",
    gts: "GTS",
    knowledgearticles: "Knowledge Articles",
    parts: "Parts",
    inventory: "Inventory",
    "workstreams-page": "Workstream",
  };
  @ViewChild("publisherDiv") publisherDiv: ElementRef;

  showDraftNotification = false;
  draftNotificationData: any = null;
  draftMsg: Message[] = [];

  constructor(private _renderer2: Renderer2, @Inject(DOCUMENT) private _document: Document,private primengConfig: PrimeNGConfig,private titleService: Title, public call: CallsService, public notification: NotificationService, private router: Router, private themeService: ThemeService,public sharedSvc: CommonService,private authenticationService: AuthenticationService,private dashboardService: DashboardService,private apiService: ApiService,
              public allDataApiService: AllDataApiService, public authGuard: AuthGuard, private indexDbService: IndexDBStorageService) {
   this.titleService.setTitle(PlatFormNames.Collabtic);
    //this.titleService.setTitle(PlatFormNames.MahleForum);
   //this.titleService.setTitle(PlatFormNames.Tvs);
    //this.titleService.setTitle(PlatFormNames.CbaForum);

    document.addEventListener('visibilitychange', () => {

      let webVersionApp: any = '';
            let platformId = localStorage.getItem('platformId');
            let dealerCode = localStorage.getItem('dealerCode');

    if (platformId == '1' || platformId == '3' || platformId == '2') {



      switch (platformId) {
        case '1':
          webVersionApp = environment.webVersionCollabtic;
          break;
        case '3':
          webVersionApp = environment.webVersionCBA;
          break;
        case '2':
          if (this.domainId == 52) {
            webVersionApp = environment.webVersionTVS;
          }
          if (this.domainId == 82) {
            webVersionApp = environment.webVersionMAHLE;
          }
          if (this.domainId == 7) {
            webVersionApp = environment.webVersionKIA;
          }
          break;
      }
    }
      if (document.hidden) {
        if(this.userId)
          {

          this.roundCount=0;
            let currUrl = this.router.url.split('/');
            console.log(currUrl[1])
            let pageName=currUrl[1];
         if(currUrl[2])
          {
            pageName=currUrl[1]+'-detail';
          }
        let localpageTimeStamp= localStorage.getItem('pageTimeStamp');
        let currentTime=moment().local().format('MM/DD/YY HH:mm:ss');
        let currentDate=moment().local().format('YYYY-MM-DD');

          let newPageDataArr=[];
         let totalTimeSpent = moment(currentTime).diff(localpageTimeStamp, 'seconds');
         if(totalTimeSpent>300)
          {
            totalTimeSpent=300;
          }
        // alert(totalTimeSpent);
         let newthreadIds=localStorage.getItem('newPageData');
         let tIndexId=0;
         if(newthreadIds)
         {
          newPageDataArr=JSON.parse(newthreadIds);


            tIndexId = newPageDataArr.findIndex(option => option.screenName == pageName);
            console.log(tIndexId);
            if(tIndexId>=0)
             {
              console.log(tIndexId+'--'+newPageDataArr[tIndexId].actionTime);
              if(newPageDataArr[tIndexId].actionTime)
                {
                  newPageDataArr[tIndexId].actionTime=totalTimeSpent+newPageDataArr[tIndexId].actionTime;
                }

             //newPageDataArr[tIndexId].actionTime=totalTimeSpent;




             }
             else
             {

              console.log(pageName);
               newPageDataArr.push({
                actionTime:totalTimeSpent,
                screenName:pageName,
                timeStamp:currentDate,
               });
             }
          }
          else
          {

            console.log(pageName);
            newPageDataArr.push({
              actionTime:totalTimeSpent,
              screenName:pageName,
              timeStamp:currentDate,


            });
          }



        localStorage.setItem('newPageData',JSON.stringify(newPageDataArr));
         localStorage.removeItem('pageTimeStamp');
         let pageTimeStamp=moment().local().format('MM/DD/YY HH:mm:ss');
         localStorage.setItem('pageTimeStamp', pageTimeStamp);

         console.log(localStorage.getItem('newPageData'));
        }
        // do whatever you want
        // console.log('Hidden');
      }
      else {

        let currentDate=moment().local().format('YYYY-MM-DD');
        //currentDate='2024-04-24';
        let newthreadIds=localStorage.getItem('newPageData');
        let tIndexId=0;
        if(newthreadIds)
        {
         let newPageDataArr=JSON.parse(newthreadIds);
        if(newPageDataArr[0].timeStamp==currentDate)
          {
            console.log(newPageDataArr[0].timeStamp);

            setInterval(() => {
              this.roundCount=this.roundCount+1;
              console.log('5 min interval');

              if(platformId=='2' && this.domainId==52 && this.roundCount<4)
                {


              let dealerCode = localStorage.getItem('dealerCode');
             let newPageData= localStorage.getItem('newPageData');
             if(newPageData && this.userId)
              {


             var apiFormData = new FormData();
             apiFormData.append('apiKey', Constant.ApiKey);
             apiFormData.append('domainId', this.domainId);
             apiFormData.append('dealerCode', dealerCode);
             apiFormData.append('userId', this.userId);
             apiFormData.append('itemValues', newPageData);
             apiFormData.append('appVersion', webVersionApp);
             apiFormData.append('platform', '3');
             apiFormData.append('timeStamp', newPageDataArr[0].timeStamp);


           this.dashboardService.apiGetactionuseractivity(apiFormData).subscribe((response) => {
           // localStorage.removeItem('newPageData');
              });
            }

            }
             // alert(2);
            }, 300000);

          }
          else
          {
            if(platformId=='2' && this.domainId==52)
              {


            let dealerCode = localStorage.getItem('dealerCode');
           let newPageData= localStorage.getItem('newPageData');
           if(newPageData && this.userId)
            {


           var apiFormData = new FormData();
           apiFormData.append('apiKey', Constant.ApiKey);
           apiFormData.append('domainId', this.domainId);
           apiFormData.append('dealerCode', dealerCode);
           apiFormData.append('userId', this.userId);
           apiFormData.append('itemValues', newPageData);
           apiFormData.append('appVersion', webVersionApp);
           apiFormData.append('platform', '3');
           apiFormData.append('timeStamp', newPageDataArr[0].timeStamp);


         this.dashboardService.apiGetactionuseractivity(apiFormData).subscribe((response) => {
          localStorage.removeItem('newPageData');
            });
          }

          }
        }
        }

        let localpageTimeStamp= localStorage.getItem('pageTimeStamp');
    if(!localpageTimeStamp)
      {
        let pageTimeStamp=moment().local().format('MM/DD/YY HH:mm:ss');
        localStorage.setItem('pageTimeStamp', pageTimeStamp);
      }
        // do whatever you want
        if (this.notification.visibility) {
          this.notification.visibility.next(true);
          setTimeout(() => {
            this.notification.visibility.next(false);
          }, 5000);
        }
      }
    });

    // Collabtic setup
    // this.platformId = PlatFormType.Collabtic;
    // this.PlatFormName = PlatFormNames.Collabtic;

    // Mahle setup
   //this.platformId = PlatFormType.MahleForum;
    //this.PlatFormName = PlatFormNames.MahleForum;
    //this.PlatFormName = PlatFormNames.Tvs;

    // CBA setup
    this.platformId = PlatFormType.CbaForum;
    this.PlatFormName = PlatFormNames.CbaForum;

    const platform: any = this.platformId;
    this.themeService.attachTheme(platform);
  }

  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  systemMsg: Message[];
  toastTimeoutId: any;

  ngOnInit(): void {

    this.allDataApiService.handleAllDataRedirection();
    this.sharedSvc.showToastMessage.subscribe((message) => {
      if (this.toastTimeoutId) clearTimeout(this.toastTimeoutId);
      this.systemMsg = [{severity: message.type, detail: message.message}];
      //this.primengConfig.ripple = true;
        this.toastTimeoutId = setTimeout(() => {
          this.systemMsg = [];
        }, (message?.timeout || 5000));
      });

    if(window.location.host=='collabticfixes.collabtic.com' || window.location.host=='forum-dev-fixes-collabtic.collabtic.com')
    {
      localStorage.setItem('domainId','336');
    }

    this.sharedSvc.draftNotificationSubject.subscribe((data) => {
      console.log("draftNotificationSubject", data);
        if (data?.threadId) {
            this.showDraftNotification = true;
            this.draftNotificationData = data;
            this.draftMsg = [{severity: 'info', summary: 'Draft message saved', detail: ''}];

            setTimeout(() => {
              this.showDraftNotification = false;
              this.draftNotificationData = null;
              this.draftMsg = [];
            }, 6000); // 6 seconds
        } 
        // else {
        //     this.showDraftNotification = false;
        //     this.draftNotificationData = null;
        //     this.draftMsg = [];
        // }
    });


    /*const script = this._renderer2.createElement('script');
    script.id = 'velox';
    script.src = 'https://velox.transactiongateway.com/token/Collect.js';
    if (this.platformId == '1') {
      if (window.location.host == 'repairify.collabtic.com' || window.location.host == 'repairify-stage.collabtic.com' || window.location.host == 'atgtraining-stage.collabtic.com' || window.location.host == 'repairifysso.collabtic.com') {
        // Repairify Token

        script.setAttribute('data-tokenization-key', environment.paymentKeys.atg);

      }
      else {
        // MarketPlace Collabtic Token

        script.setAttribute('data-tokenization-key', environment.paymentKeys.collabtic);
      }
      this._renderer2.appendChild(this._document.body, script);
    }*/

    localStorage.setItem('platformId', this.platformId);
    localStorage.setItem('platformName', this.PlatFormName);

    this.changeIcon();
    // user activity start
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      let user : any;
      let currUrl = this.router.url.split('/');
      let type = "View";
      let urlLen = currUrl.length;
      if(urlLen>2){
        if(currUrl[2] == 'manage' && currUrl[3]== undefined){
          type = "Create";
        }
        /*if(currUrl[3]!= undefined && currUrl[3] =='edit'){
          type = "Edit";
        }*/
      }
      user = this.authenticationService.userValue;
      if(user != null){
        let currUrl = event.url.split('/');
        let navFrom = currUrl[1];
        let contentTypeId = "";
        let countryId = localStorage.getItem('countryId');
        let domain_id = user.domain_id;
        this.domainId=domain_id;
        let user_id = user.Userid;
        this.userId=user.Userid;
        let roleId = user.roleId;
        let tvsFlag = (this.platformId == '2' && domain_id == 52) ? true : false;
        if(this.apiService.enableAccessLevel){
          let apiData = {
            'apiKey': Constant.ApiKey,
            'userId': user_id,
            'domainId': domain_id,
            'roleId': roleId,
            'adminPage' : 0
          };
          this.dashboardService.getRolesAndPermissions(apiData).subscribe((roles) => {
            localStorage.setItem('param',JSON.stringify(roles));
            let rolesData = roles;
            if(rolesData){
              let filtered = rolesData.items.find(
                (item) => item.name == this.maper[currUrl[1]]
              );
              if (filtered !== undefined) {
                let newFiltered = filtered?.pageAccess.find(
                (item) => item.name == type
                );
                let permission = newFiltered?.roles?.find(
                (role) => role.id == roleId
                );
                console.log(type);
                console.log(this.maper[currUrl[1]]);
                console.log(permission?.access);
                if(permission?.access == 0){
                  this.router.navigate(["/no-permission"]);
                  return false;
                }
              }
            }
          });
        }
        if(tvsFlag){
          setTimeout(() => {
            switch(navFrom){
              case 'threads':
                contentTypeId = loginActivity.threadsPage;
                break;
              case 'documents':
                contentTypeId = loginActivity.documentPage;
                break;
              case 'parts':
                contentTypeId = loginActivity.partsPage;
                break;
              case 'gts':
                contentTypeId = loginActivity.gtsPage;
                break;
              case 'sib':
                contentTypeId = loginActivity.sibPage;
                break;
              case 'workstreams-page':
                contentTypeId = loginActivity.workstreamsPage;
                break;
              default:
                contentTypeId = "";
                break;
            }
            let data = {
              apikey : Constant.ApiKey,
              domain_id : domain_id,
              user_id : user_id,
              contentTypeId : contentTypeId,
              countryId : countryId,
            }
            this.sharedSvc.getPageAction(data).subscribe((response) => {
              console.log(response)
            });
          },2000);
        }
      }
    });
// user activity end
  }

  changeIcon() {
    let platformId = localStorage.getItem("platformId");
    let favUrl = "";
    if (platformId == PlatFormType.Collabtic) {
      favUrl = "favicon.ico";
    } else if (platformId == PlatFormType.MahleForum) {
      favUrl = "assets/favicon.ico";
    } else if (platformId == PlatFormType.CbaForum) {
      favUrl = "assets/cba/favicon.ico";
    } else if (platformId == PlatFormType.KiaForum) {
      favUrl = "assets/favicon.ico";
    } else {
      favUrl = "favicon.ico";
    }

    this.favIcon.href = favUrl;
  }

  async discardDraft() {
    if (this.draftNotificationData) {
        const { domainId, userId, threadId } = this.draftNotificationData;
        const localKey = `draft-${domainId}-${userId}-${threadId}`;
        const localAttachKey = `draft-attach-${domainId}-${userId}-${threadId}`;
        const localSelectedUsersKey = `draft-users-${domainId}-${userId}-${threadId}`;
        const localDateKey = `draft-date-${domainId}-${userId}-${threadId}`;
        
        try {
            await this.indexDbService?.deleteRecord(localKey);
            await this.indexDbService?.deleteRecord(localAttachKey);
            await this.indexDbService?.deleteRecord(localSelectedUsersKey);
            await this.indexDbService?.deleteRecord(localDateKey);
            console.log(`Global Discard: Deleted records for thread ${threadId}`);
            this.sharedSvc.draftNotificationDiscardSubject.next({threadId});
            this.closeDraftNotification();
        } catch (err) {
            console.error('Error deleting draft from notification:', err);
        }
    }
  }

  closeDraftNotification() {
      this.showDraftNotification = false;
      this.draftNotificationData = null;
      this.draftMsg = [];
  }
}

window.onbeforeunload = function () {
  return "Do you really want to close?";
};
